(() => {
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-ess-editorial-columns]');
    if (!control) return;

    const section = control.closest('[data-ess-editorial-collection]');
    if (!section) return;

    section.dataset.essEditorialColumns = control.dataset.essEditorialColumns;
    section.querySelectorAll('[data-ess-editorial-columns]').forEach((button) => {
      button.classList.toggle('is-selected', button === control);
      button.setAttribute('aria-pressed', String(button === control));
    });
  });
})();
